import React from "react";

import ContentCore from "../../../../core/workingContent";

import "../../_index.css";

const TaskMyself = () => {
  return (
    <>
      <ContentCore />
    </>
  );
};

export default TaskMyself;
